import React from "react";
import { MapPin } from "lucide-react";

const IMG =
  "https://images.unsplash.com/photo-1721332154191-ba5f1534266e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  return (
    <section id="om-oss" className="py-16 sm:py-24 bg-offwhite" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-sm font-semibold uppercase tracking-widest text-electric">Om oss</span>
            <h2 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-navy">Om MobilHub</h2>
            <p className="mt-4 text-base leading-relaxed text-ink/80">
              MobilHub er et lokalt verksted i Oslo som reparerer mobiltelefoner, nettbrett,
              Mac og PC. Målet vårt er å tilby rask service, ærlige vurderinger og gode
              løsninger tilpasset hver enkelt kunde.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-hairline bg-white px-4 py-2 text-sm font-medium text-navy shadow-sm">
              <MapPin className="w-4 h-4 text-electric" /> Lokalt verksted i Oslo
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden border border-hairline shadow-sm">
              <img src={IMG} srcSet={`${IMG.replace("w=1200", "w=700")} 700w, ${IMG} 1200w`} sizes="(min-width: 1024px) 50vw, 100vw" loading="lazy" decoding="async" alt="MobilHub verksted" className="w-full h-72 sm:h-96 object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
